export default {
  js: {
    name: 'JavaScript'
  },
  nodeJs: {
    name: 'Node.js',
    url: 'https://nodejs.org'
  },
  expressJs: {
    name: 'Express.js',
    url: 'https://expressjs.com'
  },
  styledComponents: {
    name: 'styled-components',
    url: 'https://styled-components.com'
  },
  socketIO: {
    name: 'socket.io',
    url: 'https://socket.io'
  },
  ImmutableJS: {
    name: 'Immutable.js',
    url: 'https://facebook.github.io/immutable-js'
  },
  babel: {
    name: 'Babel',
    url: 'https://babeljs.io'
  },
  react: {
    name: 'React',
    url: 'https://reactjs.org'
  },
  reactNative: {
    name: 'React Native',
    url: 'https://reactnative.dev'
  },
  esLint: {
    name: 'ESLint',
    url: 'http://eslint.org'
  },
  android: {
    name: 'Android',
    url: 'https://www.android.com'
  },
  iOS: {
    name: 'iOS'
  },
  ChromeExtension: {
    name: 'Chrome Extension'
  },
  prettier: {
    name: 'Prettier',
    url: 'https://prettier.io'
  },
  tensorFlow: {
    name: 'TensorFlow',
    url: 'https://www.tensorflow.org'
  },
  tensorFlowLite: {
    name: 'TensorFlow Lite',
    url: 'https://www.tensorflow.org/lite'
  },
  faceApi: {
    name: 'face-api.js',
    url: 'https://github.com/justadudewhohacks/face-api.js'
  },
  ChromeDevTools: {
    name: 'Chrome DevTools'
  },
  Redux: {
    name: 'Redux',
    url: 'http://redux.js.org'
  },
  reduxThunk: {
    name: 'Redux Thunk',
    url: 'https://github.com/reduxjs/redux-thunk'
  },
  SSR: {
    name: 'Server-side rendering'
  },
  SSG: {
    name: 'Static site generators'
  },
  rollup: {
    name: 'Rollup',
    url: 'https://rollupjs.org'
  },
  CSS: {
    name: 'CSS'
  },
  figma: {
    name: 'Figma',
    url: 'https://www.figma.com'
  },
  Sass: {
    name: 'Sass',
    url: 'https://sass-lang.com'
  },
  threeJs: {
    name: 'three.js',
    url: 'https://threejs.org'
  },
  WebGL: {
    name: 'WebGL'
  },
  dotNetFramework: {
    name: '.NET Framework'
  },
  dotNetCore: {
    name: '.NET Core'
  },
  puppeteer: {
    name: 'puppeteer',
    url: 'https://pptr.dev'
  },
  expo: {
    name: 'Expo',
    url: 'https://expo.io'
  },
  electron: {
    name: 'Electron',
    url: 'https://www.electronjs.org'
  },
  kotlin: {
    name: 'Kotlin',
    url: 'https://kotlinlang.org'
  },
  swift: {
    name: 'Swift',
    url: 'https://developer.apple.com/swift/'
  },
  go: {
    name: 'go',
    url: 'https://go.dev'
  },
  java: {
    name: 'Java'
  },
  redash: {
    name: 'Redash',
    url: 'https://redash.io'
  },
  bigQuery: {
    name: 'BigQuery',
    url: 'https://cloud.google.com/bigquery'
  },
  kibana: {
    name: 'Kibana',
    url: 'https://www.elastic.co/kibana/'
  },
  grafana: {
    name: 'Grafana',
    url: 'https://grafana.com'
  },
  amplitude: {
    name: 'Amplitude',
    url: 'https://amplitude.com'
  },
  googleAdManager: {
    name: 'Google Ad Manager',
    url: 'https://admanager.google.com'
  },
  hapi: {
    name: 'Hapi.js',
    url: 'https://hapi.dev'
  },
  firebase: {
    name: 'Firebase',
    url: 'https://firebase.google.com'
  },
  xcode: {
    name: 'Xcode',
    url: 'https://developer.apple.com/xcode'
  },
  androidStudio: {
    name: 'Android Studio',
    url: 'https://developer.android.com/studio'
  },
  confluence: {
    name: 'Confluence',
    url: 'https://www.atlassian.com/software/confluence'
  },
  itly: {
    name: 'Itly'
  },
  openCV: {
    name: 'OpenCV',
    url: 'https://opencv.org'
  },
  webAssembly: {
    name: 'WebAssembly',
    url: 'https://webassembly.org'
  },
  nginx: {
    name: 'nginx',
    url: 'https://www.nginx.com'
  },
  mongoDB: {
    name: 'MongoDB',
    url: 'https://www.mongodb.com'
  },
  mongoose: {
    name: 'mongoose',
    url: 'https://mongoosejs.com'
  },
  mongoDBCompass: {
    name: 'MongoDB Compass',
    url: 'https://www.mongodb.com/products/compass'
  },
  typeScript: {
    name: 'TypeScript',
    url: 'https://www.typescriptlang.org'
  },
  ciCd: {
    name: 'CI/CD'
  },
  ssh: {
    name: 'SSH'
  },
  elk: {
    name: 'ELK Stack',
    url: 'https://www.elastic.co/elk-stack'
  },
  storybook: {
    name: 'Storybook',
    url: 'https://storybook.js.org'
  },
  redis: {
    name: 'Redis',
    url: 'https://redis.io'
  },
  Jenkins: {
    name: 'Jenkins',
    url: 'https://jenkins.io'
  },
  GitLab: {
    name: 'GitLab',
    url: 'https://about.gitlab.com'
  },
  HTML: {
    name: 'HTML'
  },
  HTTPS: {
    name: 'HTTP(S)'
  },
  REST: {
    name: 'REST'
  },
  JWT: {
    name: 'JWT'
  },
  npm: {
    name: 'npm'
  },
  yarn: {
    name: 'yarn'
  },
  Webpack: {
    name: 'Webpack'
  },
  Jest: {
    name: 'Jest'
  },
  MobX: {
    name: 'MobX'
  },
  CSharp: {
    name: 'C#'
  },
  XAML: {
    name: 'XAML',
    abbr: 'Extensible Application Markup Language'
  },
  SQL: {
    name: 'SQL'
  },
  LINQ: {
    name: 'LINQ'
  },
  WindowsPhone: {
    name: 'Windows Phone'
  },
  WindowsStore: {
    name: 'Windows Store'
  },
  ReSharper: {
    name: 'ReSharper'
  },
  EntityFramework: {
    name: 'Entity Framework'
  },
  net: {
    name: '.NET',
    url: 'https://dotnet.microsoft.com'
  },
  ASPDotNet: {
    name: 'ASP.NET',
    url: 'https://www.asp.net'
  },
  ASPDotNetCore: {
    name: 'ASP.NET Core'
  },
  MsSQL: {
    name: 'MS SQL',
    abbr: 'Microsoft SQL Server'
  },
  xUnit: {
    name: 'xUnit',
    url: 'https://xunit.net'
  },
  mySql: {
    name: 'MySQL',
    url: 'https://www.mysql.com'
  },
  mySqlWorkbench: {
    name: 'MySQL Workbench',
    url: 'https://www.mysql.com/products/workbench'
  },
  Azure: {
    name: 'Microsoft Azure',
    url: 'https://azure.microsoft.com'
  },
  AWS: {
    name: 'AWS',
    url: 'https://aws.amazon.com'
  },
  AWSS3: {
    name: 'Amazon S3',
    url: 'https://aws.amazon.com/s3'
  },
  MVC: {
    name: 'MVC',
    abbr: 'Model-View-Controllel'
  },
  APM: {
    name: 'APM'
  },
  APMSentry: {
    name: 'APM (Sentry.io)',
    url: 'https://sentry.io'
  },
  APMAzure: {
    name: 'APM (Azure Application Insights)',
    url: 'https://azure.microsoft.com/en-us/services/monitor'
  },
  stripe: {
    name: 'Stripe',
    url: 'https://stripe.com'
  },
  paddle: {
    name: 'paddle',
    url: 'https://paddle.com'
  },
  MVVM: {
    name: 'MVVM',
    abbr: 'Model-view-viewmodel'
  },
  IIS: {
    name: 'IIS',
    abbr: 'Internet Information Services'
  },
  Docker: {
    name: 'Docker',
    url: 'https://www.docker.com'
  },
  DockerCompose: {
    name: 'Docker Compose',
    url: 'https://docs.docker.com/compose'
  },
  visualStudioCode: {
    name: 'Visual Studio Code',
    url: 'https://code.visualstudio.com'
  },
  visualStudio: {
    name: 'Visual Studio',
    url: 'https://www.visualstudio.com'
  },
  webSockets: {
    name: 'WebSockets'
  },
  git: {
    name: 'Git',
    url: 'https://git-scm.com'
  },
  GitHub: {
    name: 'GitHub',
    url: 'https://github.com'
  },
  GitHubPages: {
    name: 'GitHub Pages',
    url: 'https://pages.github.com'
  },
  GitHubActions: {
    name: 'GitHub Actions',
    url: 'https://github.com/features/actions'
  },
  jira: {
    name: 'Jira',
    url: 'https://www.atlassian.com/software/jira'
  },
  GoogleAnalytics: {
    name: 'Google Analytics',
    url: 'https://www.google.com/analytics'
  },
  cloudflare: {
    name: 'Cloudflare',
    url: 'https://www.cloudflare.com'
  },
  CPlusPlus: {
    name: 'C++'
  },
  DirectX9: {
    name: 'DirectX 9'
  },
  DirectX11: {
    name: 'DirectX 11'
  },
  Haskell: {
    name: 'Haskell'
  },
  responsiveDesign: {
    name: 'Responsive design'
  },
  flexBox: {
    name: 'Flexbox'
  },
  grid: {
    name: 'Grid'
  },
  webSecurity: {
    name: 'Web security'
  },
  english: {
    name: 'English (B2)'
  },
  polish: {
    name: 'Polish (native)'
  },
  scrum: {
    name: 'Scrum'
  },
  scrumMaster: {
    name: 'Scrum Master'
  },
  agile: {
    name: 'Agile'
  },
  kanban: {
    name: 'Kanban'
  },
  mentorship: {
    name: 'Mentorship'
  },
  unitTesting: {
    name: 'Unit testing'
  },
  e2e: {
    name: 'End-to-end testing'
  },
  codeReview: {
    name: 'Code review'
  },
  ngrok: {
    name: 'ngrok',
    url: 'https://ngrok.com'
  },
  XNA: {
    name: 'XNA'
  },
  NextJs: {
    name: 'Next.js',
    url: 'https://nextjs.org'
  },
  WebdriverIO: {
    name: 'WebdriverIO',
    url: 'https://webdriver.io'
  },
  SSE: {
    name: 'Server-Sent Events',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events'
  },
  WebExtensions: {
    name: 'Web Extensions',
    url: 'https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions'
  },
  TailwindCSS: {
    name: 'Tailwind CSS',
    url: 'https://tailwindcss.com'
  },
  Auth0: {
    name: 'Auth0',
    url: 'https://auth0.com'
  },
  Kubernetes: {
    name: 'Kubernetes',
    url: 'https://kubernetes.io'
  },
  Datadog: {
    name: 'Datadog',
    url: 'https://www.datadoghq.com'
  },
  CircleCI: {
    name: 'CircleCI',
    url: 'https://circleci.com'
  },
  playwright: {
    name: 'Playwright',
    url: 'https://playwright.dev'
  },
  checkly: {
    name: 'Checkly',
    url: 'https://www.checklyhq.com'
  },
  axe: {
    name: 'axe (accessibility)',
    url: 'https://www.deque.com/axe/'
  },
  visualRegression: {
    name: 'Visual regression testing'
  },
  zod: {
    name: 'Zod',
    url: 'https://zod.dev'
  },
  i18n: {
    name: 'i18n'
  },
  postgreSQL: {
    name: 'PostgreSQL',
    url: 'https://www.postgresql.org'
  },
  pgvector: {
    name: 'pgvector',
    url: 'https://github.com/pgvector/pgvector'
  },
  cloudflareWorkers: {
    name: 'Cloudflare Workers',
    url: 'https://workers.cloudflare.com'
  },
  vercel: {
    name: 'Vercel',
    url: 'https://vercel.com'
  },
  postHog: {
    name: 'PostHog',
    url: 'https://posthog.com'
  },
  claudeCode: {
    name: 'Claude Code',
    url: 'https://claude.com/claude-code'
  },
  codex: {
    name: 'Codex',
    url: 'https://openai.com/codex'
  },
  agentSkills: {
    name: 'Agent Skills'
  },
  mcp: {
    name: 'Model Context Protocol (MCP)',
    url: 'https://modelcontextprotocol.io'
  },
  openAIApi: {
    name: 'OpenAI API',
    url: 'https://platform.openai.com'
  },
  rag: {
    name: 'RAG'
  },
  embeddings: {
    name: 'Embeddings'
  },
  llmAsJudge: {
    name: 'LLM-as-judge'
  },
  evals: {
    name: 'Evals'
  },
  guardrails: {
    name: 'Guardrails'
  },
  promptEngineering: {
    name: 'Prompt and context engineering'
  },
  toolCalling: {
    name: 'Tool-call orchestration'
  },
  owaspAsvs: {
    name: 'OWASP ASVS',
    url: 'https://owasp.org/www-project-application-security-verification-standard/'
  },
  oauth: {
    name: 'OAuth 2.0'
  },
  imap: {
    name: 'IMAP'
  },
  casa: {
    name: 'CASA Tier 2'
  },
  wcag: {
    name: 'WCAG 2.2 AA'
  },
  appStore: {
    name: 'App Store'
  },
  openApi: {
    name: 'OpenAPI / Swagger',
    url: 'https://www.openapis.org'
  }
}
